import democracy_contract from '../../../../build/contracts/Democracy.json'
import store from '../../../store'
import lightwallet from 'eth-lightwallet'

const contract = require('truffle-contract')

function transactionUpdated(transaction) {
    return {
        type: 'SET_TRANSACTION',
        payload: transaction
    }
}

export function sendRawTransaction(keystore, proposalId, proposalVote, password, passwordRepeat) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {
        
        return function(dispatch) {

            if (password.length < 6){

                return dispatch(transactionUpdated({checkLoading: false,
                        checkErrorMessage: true,
                        checkErrorMessageText: 'Password not long enough.',
                        showHashModal: false, 
                        transactionHash: ''}))
            }
            if (password !== passwordRepeat){
               
                return dispatch(transactionUpdated({checkLoading: false,
                        checkErrorMessage: true,
                        checkErrorMessageText: 'Passwords don\'t match.',
                        showHashModal: false, 
                        transactionHash: ''}))
            }
            
            dispatch(transactionUpdated({checkLoading: true,
                checkErrorMessage: false,
                checkErrorMessageText: '',
                showHashModal: false, 
                transactionHash: ''}))
            
            web3.eth.getGasPrice(function(error, result){

                if (!error){
                    let gasPriceHex =  web3.toHex(result);
                    let gasLimitHex =  web3.toHex('1000000');
                    
                    let ks = lightwallet.keystore.deserialize(keystore)
                    let address = ks.getAddresses();
                    
                    web3.eth.getTransactionCount(address[0], function(error, result){

                        if (!error){
                            let nonceHex = web3.toHex(result);

                            const DemocracyContract = contract(democracy_contract)
                            DemocracyContract.setProvider(web3.currentProvider)

                            let cInstance
                            
                            DemocracyContract.deployed().then((contractInstance) => {
                                cInstance = contractInstance
                                
                                let rawTx = {
                                    nonce: nonceHex,
                                    gasPrice: gasPriceHex,
                                    gasLimit: gasLimitHex,
                                    to: cInstance.address,
                                    from: address[0],
                                    value: web3.toHex('0'),
                                    chainId: web3.toHex('4')
                                }
                                
                                let voteTx = lightwallet.txutils.functionTx(democracy_contract.abi, 'vote', [proposalId,proposalVote], rawTx)

                                ks.keyFromPassword(password, function(err, pwDerivedKey) {
                                    if (!ks.isDerivedKeyCorrect(pwDerivedKey)){
                                        return dispatch(transactionUpdated({checkLoading: false,
                                            checkErrorMessage: true,
                                            checkErrorMessageText: 'Password is incorrect.',
                                            showHashModal: false, 
                                            transactionHash: ''}))
                                    }
                                    let signedTx = lightwallet.signing.signTx(ks, pwDerivedKey, voteTx, address[0])

                                    web3.eth.sendRawTransaction('0x' + signedTx,function(error, hash){
                                        if (!error){

                                            let filter = web3.eth.filter("latest",function(error, blockHash) {
                                                if (!error) {
                                                    web3.eth.getBlock(blockHash, function(error, result){
                                                        if(!error) {
                                                            if (result.transactions.length > 0 && result.transactions.includes(hash)) {
                                                               
                                                                filter.stopWatching(function(error){
                                                                    if(!error) {
                                                                        
                                                                        web3.eth.getTransactionReceipt(hash, function(error, result){
                                                                            if(!error) {
        
                                                                                if(web3.toDecimal(result.status) === 1){
                                                                                    return dispatch(transactionUpdated({checkLoading: false,
                                                                                        checkErrorMessage: false,
                                                                                        checkErrorMessageText: '',
                                                                                        showHashModal: true, 
                                                                                        transactionHash: hash}))
                                                                                    
                                                                                } else {

                                                                                    return dispatch(transactionUpdated({checkLoading: false,
                                                                                        checkErrorMessage: true,
                                                                                        checkErrorMessageText: 'Transaction failed.',
                                                                                        showHashModal: false, 
                                                                                        transactionHash: ''}))
                                                                                }
                                                                            } else {
                                                                                return dispatch(transactionUpdated({checkLoading: false,
                                                                                    checkErrorMessage: true,
                                                                                    checkErrorMessageText: 'Something is wrong.',
                                                                                    showHashModal: false, 
                                                                                    transactionHash: ''}))
                                                                            }
                                                                        })
                                                                    } else {
                                                                        return dispatch(transactionUpdated({checkLoading: false,
                                                                            checkErrorMessage: true,
                                                                            checkErrorMessageText: 'Something is wrong.',
                                                                            showHashModal: false, 
                                                                            transactionHash: ''}))
                                                                    }
                                                                })        
                                                            } 
                                                        } else {
                                                            return dispatch(transactionUpdated({checkLoading: false,
                                                                checkErrorMessage: true,
                                                                checkErrorMessageText: 'Something is wrong.',
                                                                showHashModal: false, 
                                                                transactionHash: ''}))
                                                        }
                                                    })     
                                                } else {
                                                    return dispatch(transactionUpdated({checkLoading: false,
                                                        checkErrorMessage: true,
                                                        checkErrorMessageText: 'Something is wrong.',
                                                        showHashModal: false, 
                                                        transactionHash: ''}))
                                                }
                                            })
                                        } else {
                                            return dispatch(transactionUpdated({checkLoading: false,
                                                checkErrorMessage: true,
                                                checkErrorMessageText: 'Something is wrong.',
                                                showHashModal: false, 
                                                transactionHash: ''}))
                                        } 
                                    })
                                })
                            })
                        } else {
                            return dispatch(transactionUpdated({checkLoading: false,
                                checkErrorMessage: true,
                                checkErrorMessageText: 'Something is wrong.',
                                showHashModal: false, 
                                transactionHash: ''}))
                        }
                    })
                } else {
                    return dispatch(transactionUpdated({checkLoading: false,
                        checkErrorMessage: true,
                        checkErrorMessageText: 'Something is wrong.',
                        showHashModal: false, 
                        transactionHash: ''}))
                }
            })  
        }    
    } else {
        console.error('Web3 is not initialized.');
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/transactions/Voting.js